// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: SG-G6MD1MQ
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicBrandsSummaryTitle.module.css"; // plasmic-import: SG-G6MD1MQ/css

createPlasmicElementProxy;

export const PlasmicBrandsSummaryTitle__VariantProps = new Array();

export const PlasmicBrandsSummaryTitle__ArgProps = new Array(
  "cityIn",
  "agggScore",
  "brandName"
);

const $$ = {};

function PlasmicBrandsSummaryTitle__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox___4PnBf)}>
        <div className={classNames(projectcss.all, sty.freeBox__fep6G)}>
          <h1
            data-plasmic-name={"h1"}
            data-plasmic-override={overrides.h1}
            className={classNames(projectcss.all, projectcss.h1, sty.h1)}
          >
            {renderPlasmicSlot({
              defaultContents: "Brands",
              value: args.brandName,
              className: classNames(sty.slotTargetBrandName)
            })}
          </h1>
          <div className={classNames(projectcss.all, sty.freeBox__gYl2T)}>
            <div
              data-plasmic-name={"locationProp"}
              data-plasmic-override={overrides.locationProp}
              className={classNames(projectcss.all, sty.locationProp)}
            >
              {renderPlasmicSlot({
                defaultContents: "Dubai",
                value: args.cityIn,
                className: classNames(sty.slotTargetCityIn)
              })}
            </div>
            <div
              data-plasmic-name={"locationsStr2"}
              data-plasmic-override={overrides.locationsStr2}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.locationsStr2
              )}
            >
              {"locations"}
            </div>
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__tan4D)}>
          <div className={classNames(projectcss.all, sty.freeBox__jTqVd)}>
            <div
              data-plasmic-name={"vertical"}
              data-plasmic-override={overrides.vertical}
              className={classNames(projectcss.all, sty.vertical)}
            >
              {renderPlasmicSlot({
                defaultContents: "88",
                value: args.agggScore,
                className: classNames(sty.slotTargetAgggScore)
              })}
            </div>
            <div
              data-plasmic-name={"hundred"}
              data-plasmic-override={overrides.hundred}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.hundred
              )}
            >
              {" /100"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "h1", "locationProp", "locationsStr2", "vertical", "hundred"],
  h1: ["h1"],
  locationProp: ["locationProp"],
  locationsStr2: ["locationsStr2"],
  vertical: ["vertical"],
  hundred: ["hundred"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBrandsSummaryTitle__ArgProps,
          internalVariantPropNames: PlasmicBrandsSummaryTitle__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBrandsSummaryTitle__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBrandsSummaryTitle";
  } else {
    func.displayName = `PlasmicBrandsSummaryTitle.${nodeName}`;
  }
  return func;
}

export const PlasmicBrandsSummaryTitle = Object.assign(
  // Top-level PlasmicBrandsSummaryTitle renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    h1: makeNodeComponent("h1"),
    locationProp: makeNodeComponent("locationProp"),
    locationsStr2: makeNodeComponent("locationsStr2"),
    vertical: makeNodeComponent("vertical"),
    hundred: makeNodeComponent("hundred"),
    // Metadata about props expected for PlasmicBrandsSummaryTitle
    internalVariantProps: PlasmicBrandsSummaryTitle__VariantProps,
    internalArgProps: PlasmicBrandsSummaryTitle__ArgProps
  }
);

export default PlasmicBrandsSummaryTitle;
/* prettier-ignore-end */
